/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  GeneralMeetingRequest,
  LoanReminderRequest,
  ProductChangeRequest,
  PromotionalNotificationRequest,
  SendCustomBulkSms200,
  SendCustomBulkSmsBody,
  SendCustomBulkSmsParams,
  SendGeneralMeetingNotifications200,
  SendProductChangeNotifications200,
  SendPromotionalNotifications200,
  TriggerLoanOverdueNotices200,
  TriggerLoanReminders200
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const sendPromotionalNotifications = (
    promotionalNotificationRequest: PromotionalNotificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendPromotionalNotifications200>(
      {url: `/api/v1/trigger-notifications/promotional`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: promotionalNotificationRequest, signal
    },
      options);
    }
  


export const getSendPromotionalNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPromotionalNotifications>>, TError,{data: PromotionalNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendPromotionalNotifications>>, TError,{data: PromotionalNotificationRequest}, TContext> => {

const mutationKey = ['sendPromotionalNotifications'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendPromotionalNotifications>>, {data: PromotionalNotificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendPromotionalNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendPromotionalNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof sendPromotionalNotifications>>>
    export type SendPromotionalNotificationsMutationBody = PromotionalNotificationRequest
    export type SendPromotionalNotificationsMutationError = unknown

    export const useSendPromotionalNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendPromotionalNotifications>>, TError,{data: PromotionalNotificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendPromotionalNotifications>>,
        TError,
        {data: PromotionalNotificationRequest},
        TContext
      > => {

      const mutationOptions = getSendPromotionalNotificationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const sendProductChangeNotifications = (
    productChangeRequest: ProductChangeRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendProductChangeNotifications200>(
      {url: `/api/v1/trigger-notifications/product-change`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productChangeRequest, signal
    },
      options);
    }
  


export const getSendProductChangeNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendProductChangeNotifications>>, TError,{data: ProductChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendProductChangeNotifications>>, TError,{data: ProductChangeRequest}, TContext> => {

const mutationKey = ['sendProductChangeNotifications'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendProductChangeNotifications>>, {data: ProductChangeRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendProductChangeNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendProductChangeNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof sendProductChangeNotifications>>>
    export type SendProductChangeNotificationsMutationBody = ProductChangeRequest
    export type SendProductChangeNotificationsMutationError = unknown

    export const useSendProductChangeNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendProductChangeNotifications>>, TError,{data: ProductChangeRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendProductChangeNotifications>>,
        TError,
        {data: ProductChangeRequest},
        TContext
      > => {

      const mutationOptions = getSendProductChangeNotificationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const triggerLoanReminders = (
    loanReminderRequest: LoanReminderRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TriggerLoanReminders200>(
      {url: `/api/v1/trigger-notifications/loan-reminders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanReminderRequest, signal
    },
      options);
    }
  


export const getTriggerLoanRemindersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerLoanReminders>>, TError,{data: LoanReminderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerLoanReminders>>, TError,{data: LoanReminderRequest}, TContext> => {

const mutationKey = ['triggerLoanReminders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerLoanReminders>>, {data: LoanReminderRequest}> = (props) => {
          const {data} = props ?? {};

          return  triggerLoanReminders(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerLoanRemindersMutationResult = NonNullable<Awaited<ReturnType<typeof triggerLoanReminders>>>
    export type TriggerLoanRemindersMutationBody = LoanReminderRequest
    export type TriggerLoanRemindersMutationError = unknown

    export const useTriggerLoanReminders = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerLoanReminders>>, TError,{data: LoanReminderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerLoanReminders>>,
        TError,
        {data: LoanReminderRequest},
        TContext
      > => {

      const mutationOptions = getTriggerLoanRemindersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const triggerLoanOverdueNotices = (
    loanReminderRequest: LoanReminderRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TriggerLoanOverdueNotices200>(
      {url: `/api/v1/trigger-notifications/loan-overdue`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanReminderRequest, signal
    },
      options);
    }
  


export const getTriggerLoanOverdueNoticesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerLoanOverdueNotices>>, TError,{data: LoanReminderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerLoanOverdueNotices>>, TError,{data: LoanReminderRequest}, TContext> => {

const mutationKey = ['triggerLoanOverdueNotices'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerLoanOverdueNotices>>, {data: LoanReminderRequest}> = (props) => {
          const {data} = props ?? {};

          return  triggerLoanOverdueNotices(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerLoanOverdueNoticesMutationResult = NonNullable<Awaited<ReturnType<typeof triggerLoanOverdueNotices>>>
    export type TriggerLoanOverdueNoticesMutationBody = LoanReminderRequest
    export type TriggerLoanOverdueNoticesMutationError = unknown

    export const useTriggerLoanOverdueNotices = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerLoanOverdueNotices>>, TError,{data: LoanReminderRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerLoanOverdueNotices>>,
        TError,
        {data: LoanReminderRequest},
        TContext
      > => {

      const mutationOptions = getTriggerLoanOverdueNoticesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const sendGeneralMeetingNotifications = (
    generalMeetingRequest: GeneralMeetingRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendGeneralMeetingNotifications200>(
      {url: `/api/v1/trigger-notifications/general-meeting`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generalMeetingRequest, signal
    },
      options);
    }
  


export const getSendGeneralMeetingNotificationsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGeneralMeetingNotifications>>, TError,{data: GeneralMeetingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendGeneralMeetingNotifications>>, TError,{data: GeneralMeetingRequest}, TContext> => {

const mutationKey = ['sendGeneralMeetingNotifications'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendGeneralMeetingNotifications>>, {data: GeneralMeetingRequest}> = (props) => {
          const {data} = props ?? {};

          return  sendGeneralMeetingNotifications(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendGeneralMeetingNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof sendGeneralMeetingNotifications>>>
    export type SendGeneralMeetingNotificationsMutationBody = GeneralMeetingRequest
    export type SendGeneralMeetingNotificationsMutationError = unknown

    export const useSendGeneralMeetingNotifications = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendGeneralMeetingNotifications>>, TError,{data: GeneralMeetingRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendGeneralMeetingNotifications>>,
        TError,
        {data: GeneralMeetingRequest},
        TContext
      > => {

      const mutationOptions = getSendGeneralMeetingNotificationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const sendCustomBulkSms = (
    sendCustomBulkSmsBody: SendCustomBulkSmsBody,
    params: SendCustomBulkSmsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendCustomBulkSms200>(
      {url: `/api/v1/trigger-notifications/custom-sms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendCustomBulkSmsBody,
        params, signal
    },
      options);
    }
  


export const getSendCustomBulkSmsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomBulkSms>>, TError,{data: SendCustomBulkSmsBody;params: SendCustomBulkSmsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendCustomBulkSms>>, TError,{data: SendCustomBulkSmsBody;params: SendCustomBulkSmsParams}, TContext> => {

const mutationKey = ['sendCustomBulkSms'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendCustomBulkSms>>, {data: SendCustomBulkSmsBody;params: SendCustomBulkSmsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  sendCustomBulkSms(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendCustomBulkSmsMutationResult = NonNullable<Awaited<ReturnType<typeof sendCustomBulkSms>>>
    export type SendCustomBulkSmsMutationBody = SendCustomBulkSmsBody
    export type SendCustomBulkSmsMutationError = unknown

    export const useSendCustomBulkSms = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendCustomBulkSms>>, TError,{data: SendCustomBulkSmsBody;params: SendCustomBulkSmsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendCustomBulkSms>>,
        TError,
        {data: SendCustomBulkSmsBody;params: SendCustomBulkSmsParams},
        TContext
      > => {

      const mutationOptions = getSendCustomBulkSmsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    